import { useEffect, useState } from "react";
import videoApi from "../../api/videoApi";
interface UploadVideoPopupProps {
    onClose: () => void;
    onSuccess: () => void;
}

function UploadVideoPopup(props: UploadVideoPopupProps) {
    const { onClose, onSuccess } = props;
    const [name, setName] = useState<string>("");
    const [show, setShow] = useState<boolean>(false);
    const [subject, setSubject] = useState<number>(0);
    const [url, setUrl] = useState<string>("");
    const [error, setError] = useState<string>("");

    useEffect(() => {
        setTimeout(() => setShow(true), 10);
    }, []);

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            setShow(false);
            setTimeout(onClose, 300);
        }
    };

    // const handleSubmit = async () => {

    //     if (!name) {
    //         setError("❌ Vui lòng nhập tên video.");
    //         return;
    //     }

    //     if (subject === 0) {
    //         setError("❌ Vui lòng chọn môn học.");
    //         return;
    //     }

    //     if (!url) {
    //         setError("❌ Vui lòng nhập đường dẫn video.");
    //         return;
    //     }
    //     const data =
    //     {
    //         name: name,
    //         subjectId: subject,
    //         url: url
    //     }

    //     const res = await videoApi.uploadVideo(data);
    //     console.log("res", res)
    //     setError("");
    //     onSuccess();
    //     setShow(false);
    //     setTimeout(onClose, 300);
    // };

    const formatVideoUrl = (url: string) => {
        // Google Drive share link → preview link
        const driveRegex = /https:\/\/drive\.google\.com\/file\/d\/([^/]+)\//;
        const match = url.match(driveRegex);
        if (match && match[1]) {
            return `https://drive.google.com/file/d/${match[1]}/preview`;
        }
        return url; // giữ nguyên nếu không phải Drive
    };

    const handleSubmit = async () => {

        if (!name) return setError("❌ Vui lòng nhập tên video.");
        if (subject === 0) return setError("❌ Vui lòng chọn môn học.");
        if (!url) return setError("❌ Vui lòng nhập đường dẫn video.");

        const finalUrl = formatVideoUrl(url);

        const data = {
            name,
            subjectId: subject,
            url: finalUrl
        };

        await videoApi.uploadVideo(data);

        setError("");
        onSuccess();
        setShow(false);
        setTimeout(onClose, 300);
    };

    return (
        <div
            className="fixed top-0 right-0 bottom-0 left-0 bg-[rgba(0,0,0,0.5)] z-50 flex justify-center items-center transition-opacity duration-300"
            onClick={handleOverlayClick}
            style={{ opacity: show ? 1 : 0 }}
        >
            <div
                className={`relative w-[90%] lg:w-[500px] bg-white p-[20px] rounded-box flex flex-col items-center transition-all duration-300 ${show ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"
                    }`}
            >
                <h2 className="text-secondary font-bold text-[20px] mt-[20px]">
                    Upload Video
                </h2>

                <div className="my-[20px] flex flex-col w-[80%] gap-[10px]">
                    <div className="mb-[20px]">
                        <label className="font-[600] inline-block mb-[6px]">Tiêu đề video</label>
                        <input
                            type="text"
                            placeholder="Nhập Tiêu đề video"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px]"
                        />
                    </div>
                    <div className="mb-[20px]">
                        <label className="font-[600] inline-block mb-[6px]">Môn học</label>
                        <select
                            className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px]"
                            value={subject}
                            onChange={(e) => {
                                setSubject(Number(e.target.value));
                                if (error) setError(""); // reset lỗi khi chọn môn học
                            }}                        >
                            <option value={0}>Chọn môn học</option>
                            <option value={1}>Toán</option>
                            <option value={2}>Tiếng Việt</option>
                            <option value={3}>Tiếng Anh</option>
                            <option value={4}>Khoa Học Tự Nhiên</option>
                        </select>
                    </div>
                    <div>
                        <label className="font-[600] inline-block mb-[6px]">Đường dẫn video</label>
                        <input
                            type="text"
                            placeholder="Nhập đường dẫn video"
                            onChange={e => setUrl(e.target.value)}
                            value={url}
                            className="outline-none border border-[#e0e0e0] rounded-[4px] py-[4px] px-[8px] w-full h-[46px]"
                        />
                    </div>
                    <p className="text-red-500 text-center h-[10px]">{error}</p>
                </div>
                <button
                    onClick={handleSubmit}
                    className="bg-blue-500 text-white py-[10px] px-[20px] rounded-[6px] hover:bg-blue-600 transition"
                >
                    Upload
                </button>
                <button
                    className="absolute top-[10px] right-[10px]"
                    onClick={() => setShow(false)}
                >
                    <i className="fa-solid fa-close text-[22px] text-blue-500"></i>
                </button>
            </div>
        </div>
    );
}

export default UploadVideoPopup;
